import config from '../../template.config.js'

// Pages that should get a Direct Debit button. To add another form, add a
// new entry here - typeSelectId is optional and only needed if the page has
// a contribution-type select that should hide the button when unset.
const directDebitTargets = [
    {
        // donate/contribute2
        containerSelector: '.tn-contribution-group2-page',
        submitSelector: '#tn-contribution-submit',
        typeSelectId: 'AddContribution_ContributionTypeId'
    },
    {
        // donate/q/shoe-fund, donate/q/dance-health, 
        // donate/q/works-on-screen, /donate/q/touring-music
        containerSelector: '.tn-one-page-giving-page',
        submitSelector: '#tn-opg-submit-btn'
    }
]

function findActiveDirectDebitTarget () {
    for (const target of directDebitTargets) {
        const container = document.querySelector(target.containerSelector)
        const submitBtn = container && container.querySelector(target.submitSelector)
        if (submitBtn) {
            return { ...target, container, submitBtn }
        }
    }
    return null
}

function addDirectDebitBtn (campaign, URL, target) {
    const form = `<form name="directDebitForm" method="post" action="${URL}">
        <input name="campaign" type="hidden" value="${campaign}">
    </form>`
    target.container.insertAdjacentHTML('afterend', form)

    const directDebitBtn = `<a id="directDebitButton" class="btn btn-default" href="#">Pay by Direct Debit</a>`
    target.submitBtn.insertAdjacentHTML('afterend', directDebitBtn)
}

const directDebitTarget = findActiveDirectDebitTarget()

if (directDebitTarget && config.directDebitCampaign && config.directDebitURL) {
    addDirectDebitBtn(config.directDebitCampaign, config.directDebitURL, directDebitTarget)

    // When contribution set to Select (no value) - hide button (same as rest of form)
    const typeSelection = directDebitTarget.typeSelectId && document.getElementById(directDebitTarget.typeSelectId)
    if (typeSelection) {
        typeSelection.addEventListener('change', (e) => {
            const btn = document.getElementById('directDebitButton')
            if (e.currentTarget.value === '') {
                btn.style.display = 'none'
            }
            else {
                btn.style.display = ''
            }
        })
    }

    // on click of DD button, update value from main form and submit direct debit form
    const directDebitBtn = document.getElementById('directDebitButton')
    if (directDebitBtn) {
        directDebitBtn.addEventListener('click', () => {
            document.directDebitForm.submit()
        })
    }
}

// Update all remove buttons on the cart page to ensure the removal label is displayed on the frontend
const removeItemLabels = document.querySelectorAll('.tn-cart__btn-remove-label');
if (removeItemLabels) {
    removeItemLabels.forEach(button => {
        button.classList.remove('sr-only');
    });
}
